/**
 * Shared module which contains the shared components, directives, pipes,
 * and other Angular declarations.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DirectivesModule } from '@app/components/directives/directives.module';
import { ButtonRendererComponent } from '@app/components/dm-grid/cellRender';
import { TranslateModule } from '@ngx-translate/core';

import { LoaderComponent } from '@components/loader';
import { SpinnerComponent } from '@components/spinner/spinner.component';
import { IconButtonComponent } from '@components/icon-button';

const ATOMIC_COMPONENTS = [LoaderComponent, SpinnerComponent, IconButtonComponent];

const DECLARATIONS = [ButtonRendererComponent, ...ATOMIC_COMPONENTS];

@NgModule({
  declarations: [...DECLARATIONS],
  exports: [...DECLARATIONS, TranslateModule],
  imports: [CommonModule, DirectivesModule, TranslateModule],
  providers: [],
})
export class SharedModule {}
